const APP_CONFIG = {
  USE_CACHE: true,
  EVENT_LIMIT: 75,
  SEARCH_LIMIT: 12,
  LINK_WIDTH_FACTOR: 5,
  MAX_VISIBLE_CHARS: 25,
  N_IMAGES : 3,
  VIEW_THRESHOLD: 0.5,
  BASE_OPACITY: 3,
  VIEW_LINKS: true,
  SPECTRUM: [
    'rgb(222,237,250)',
    'rgb(176,212,243)',
    'rgb(128,186,236)',
    'rgb(77,158,228)',
    'rgb(38,137,223)',
    'rgb(0,116,217)',
    'rgb(0,106,197)',
    'rgb(0,94,176)'
  ]


};

export default APP_CONFIG;
